import { ErrorMessage, Field } from "formik";
import React, { FC } from "react";
import PopoverBtn, { IPopoverBtnProps } from "../popoverBtn";

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  name: string;
  type?: string;
  label: string;
  as?: string;
  className?: string;
  labelClassName?: string;
  error?: boolean;
  tooltip?: IPopoverBtnProps;
};

export const StyledInput: FC<Props> = ({
  name,
  type = "text",
  label,
  as = "input",
  className = "",
  labelClassName = "",
  error = false,
  tooltip,
  ...rest
}) => {
  return (
    <>
      <Field
        {...rest}
        name={name}
        type={type}
        as={as}
        placeholder={label}
        className={`${className} form-control ${!className.includes("fs") && "fs-6"} ${error ? "is-invalid" : ""}`}
      />
      {tooltip?.text && !error && <PopoverBtn {...tooltip} error={error} />}
      <label
        htmlFor={name}
        className={`form-label text-gray ${!labelClassName.includes("ps") && ""} ${!labelClassName.includes("fs") && "fs-6"} ${labelClassName}`}
      >
        {label}
      </label>
      <ErrorMessage name={name} component="div" className="invalid-feedback" />
    </>
  );
};
